import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getTimeline } from '../../../api/items';

import { mergeItemsListWithUserData } from '../../../utils/items';
import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import {
  checkAndSetLoading,
  handleRequestRejection,
  matchRequest,
  resetLoading,
} from '../../../utils/asyncThunkRequest';

import { NEXT_LINK } from '../constants/itemsHeaders';

export const fetchTimeline = createAsyncThunk(
  'items/fetchTimeline',
  async ({ params } = {}, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [itemsResponse, userDataMapResponse] = await getTimeline({
        cancelToken: source.token,
        params,
      });

      return {
        data: mergeItemsListWithUserData(itemsResponse, userDataMapResponse),
        nextLink: itemsResponse.headers[NEXT_LINK] || null,
      };
    } catch (error) {
      return rejectWithValue(error?.response?.status);
    }
  },
  // {
  //   condition: (thunkData, { getState }) => {
  //     const { scrollPositionItemId } = getState().items;

  //     return !scrollPositionItemId;
  //   },
  // },
);

export const fetchTimelineExtraReducers = builder => {
  builder
    .addCase(fetchTimeline.pending, (state, action) => {
      checkAndSetLoading(state.items.display.pagination, action);
    })
    .addCase(fetchTimeline.fulfilled, (state, action) => {
      const { payload } = action;
      if (matchRequest(state.items.display.pagination, action)) {
        const byId = {};
        payload.data.items.forEach(item => {
          byId[generateItemCIDKey(item)] = item;
          if (!state.items.item.allIds.includes(item.id))
            state.items.item.allIds.push(item.id);
        });
        state.items.item.byId = { ...state.items.item.byId, ...byId };
        state.items.display.layout.push(...payload.data.layout);
        state.items.display.pagination.next = payload.nextLink;
        resetLoading(state.items.display.pagination);
      }
    })
    .addCase(fetchTimeline.rejected, (state, action) => {
      handleRequestRejection(state.items.display.pagination, action);
    });
};
